<div class="container d-flex flex-column justify-content-center align-items-center pb-5">
  <h1 class="text-danger" [translate]="Localization.NotFoundHeader"></h1>
  <h3 [translate]="Localization.NotFoundSubheader"></h3>
</div>
